/**
 * Formats a sponsor name for display.
 * Format: "{firstName} {middleName if applicable} {lastName}"
 * Example: "Joe Campbell"
 * 
 * @param {Object} sponsor - Sponsor object with name
 * @returns {string} - Formatted sponsor name
 */
export function formatSponsorName(sponsor) {
  if (!sponsor || !sponsor.name) return '';

  const name = sponsor.name.trim();

  // Parse "Last, First ..." format and reorder to "First ... Last"
  const commaMatch = name.match(/^(.+?),\s*(.+?)(?:\s+\d+(?:st|nd|rd|th))?\s*$/);
  if (commaMatch) {
    const lastName = commaMatch[1].trim();
    const firstNameAndMiddle = commaMatch[2].replace(/\s+\d+(?:st|nd|rd|th)\s*$/, '').trim();
    return `${firstNameAndMiddle} ${lastName}`.trim();
  }

  // Remove any existing district suffix from name
  const cleanedName = name.replace(/\s+\d+(?:st|nd|rd|th)\s*$/, '').trim();
  return cleanedName;
}